import { Component, OnInit } from '@angular/core';
import { MicroempresarioService } from '../services/microempresario.service';
import { UserService } from '../../services/user.service';
import { AlertService } from '../../services/alert.service';
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Decimation,
  Filler,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from 'node_modules/chart.js';
import { SweetAlertService } from '../../services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.scss'],
    providers: [MicroempresarioService],
    standalone: false
})
export class ChartComponent implements OnInit {
  user: any;
  datosGrafica: any[] = [];
  aprobadas: number = null;
  sinOfertas: number = null;
  enTramite: number = null;

  constructor(
    private _microempresarioService: MicroempresarioService,
    private _userService: UserService,
    private alertService: AlertService,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userService.getUser();
    Chart.register(
      BarElement,
      BarController,
      CategoryScale,
      Decimation,
      Filler,
      Legend,
      Title,
      Tooltip,
      LinearScale
    );
    Chart.defaults.color = 'white';
    Chart.defaults.font.size = 16;
  }

  ngOnInit(): void {
    this.cargarDatosGrafica();
  }

  cargarDatosGrafica() {
    this._microempresarioService
      .getGraficaEstados(this.user.idEmpresario)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this.datosGrafica = response['data'];
            this.aprobadas = Number(this.datosGrafica[0].aprobadas);
            this.sinOfertas = Number(this.datosGrafica[1].sinOfertas);
            this.enTramite = Number(this.datosGrafica[2].enTramite);
            this.cargarGrafica();
          } else {
            this._sweetAlert.errorModal("Error!",true,
              'No fue posible cargar los datos de la grafica'
            );
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'No fue posible conectar con el servidor');
        }
      );
  }

  cargarGrafica() {
    var ctx = $('#myChart');
    var myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: ['Aprobadas', 'Sin ofertas', 'En trámite'],
        datasets: [
          {
            label: 'Solicitudes',
            data: [
              Number(this.aprobadas),
              Number(this.sinOfertas),
              Number(this.enTramite),
            ],
            backgroundColor: [
              'rgba(105, 210, 123, 1)',
              'rgba(255, 99, 132, 1)',
              'rgba(105, 210, 182, 1)',
            ],
            //ancho de la barra
            barPercentage: 0.9,
          },
        ],
      },
      options: {
        indexAxis: 'y',
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: { display: false },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    });
  }
}
